/**
 * Centralised third-party config.
 *
 * Paste your Calendly event URL into `CALENDLY_URL` below.
 * Format: https://calendly.com/<your-handle>/<event-slug>
 * Example: https://calendly.com/sales-videra/videra-demo
 *
 * The Calendly account must be registered with sales@videra.app for
 * booking confirmations to land in that mailbox.
 *
 * Until a real URL is set, "Book demo" buttons fall back to the
 * /contact page so the site never has a dead CTA.
 */
export const CALENDLY_URL = 'https://calendly.com/videra-sales/videra-discovery-call';

/** True when a real Calendly URL has been pasted in. */
export const CALENDLY_READY = !!CALENDLY_URL && CALENDLY_URL.startsWith('https://calendly.com/');
